import {ActiveShortcutCommands, type ShortcutGroupWithCommands} from '../types';
import {getGroupByCommand} from './getGroupByCommand';
import {shortcutCommandGroups} from './shortcutCommandGroups';

export const getShortcutGroupsWithCommands = (
  ignoreEmpty?: boolean,
): ShortcutGroupWithCommands[] => {
  const collection: ShortcutGroupWithCommands[] = [];

  shortcutCommandGroups.forEach(group => {
    collection.push({
      group,
      commands: ActiveShortcutCommands.filter(
        command => getGroupByCommand(command) === group,
      ),
    });
  });

  if (ignoreEmpty) {
    return collection.filter(c => c.commands.length > 0);
  }

  return collection;
};
